import { createAction } from '@reduxjs/toolkit';

export const clearRedirectRoute = createAction('CLEAR_REDIRECT_ROUTE');
